import { DefaultTheme } from "styled-components";

const theme: DefaultTheme = {
  fonts: {
    primary: "'Source Sans Pro', sans-serif",
    secondary: "'Nunito Sans', sans-serif",
  },
  colors: {
    green: '#336b75',
    gold: '#9e866b;',
    grey: '#a8a8a8',
    white: '#fff',
    goldDarker: '#ff9933'
  },
};

export default theme;
